if (!customElements.get("anchor-opener-popup")) {
  customElements.define(
    "anchor-opener-popup",
    class AnchorOpenerPopup extends HTMLElement {
      constructor() {
        super();

        this.popupToggle = this.querySelector("modal-opener");
        this.popupModal = this.querySelector("modal-dialog");
        this.popupOpenerID = this.dataset.popupOpener;

        this.init();
      }

      connectedCallback() {
        if (Shopify.designMode) {
          this.onShopifySectionLoad = this.onSectionLoad.bind(this);
          this.onShopifySectionSelect = this.onSectionSelect.bind(this);
          this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
          document.addEventListener(
            "shopify:section:load",
            this.onShopifySectionLoad,
          );
          document.addEventListener(
            "shopify:section:select",
            this.onShopifySectionSelect,
          );
          document.addEventListener(
            "shopify:section:deselect",
            this.onShopifySectionDeselect,
          );
        }
      }
      disconnectedCallback() {
        if (Shopify.designMode) {
          document.removeEventListener(
            "shopify:section:load",
            this.onShopifySectionLoad,
          );
          document.removeEventListener(
            "shopify:section:select",
            this.onShopifySectionSelect,
          );
          document.removeEventListener(
            "shopify:section:deselect",
            this.onShopifySectionDeselect,
          );
        }
      }
      onSectionLoad(event) {
        filterShopifyEvent(event, this, this.open.bind(this));
      }
      onSectionSelect(event) {
        filterShopifyEvent(event, this, this.open.bind(this));
      }
      onSectionDeselect(event) {
        filterShopifyEvent(event, this, this.close.bind(this));
      }

      init() {
        if (!this.popupOpenerID) return;
        document.addEventListener("click", (event) => {
          let path = event.composedPath().slice(0, -2);
          let link = path.find(
            (element) =>
              element.nodeName === "A" &&
              element.getAttribute("href") == "#" + this.popupOpenerID,
          );

          if (typeof link !== "object") return;

          linkOpenerHandler(event, link);
        });

        const linkOpenerHandler = (event, element) => {
          event.preventDefault();
          this.open();
        };
      }

      open() {
        this.popupModal.show(this.popupToggle);
      }

      close() {
        this.popupModal.hide();
      }
    },
  );
}
